declare var require: any;

import * as React from 'react';
import { Icon, Tag } from '../';

const { version } = require('../../../package.json');

const Version = () => (
  <Tag type="default">
    <small>
      <Icon icon="code-fork" />
    </small>
    &nbsp; v{version}
  </Tag>
);

export default Version;
